export default __webpack_public_path__ + "static/media/044-departure_2.662e106d.svg";